export class UserInfo {
  constructor() {
    this.settings = new UserSettings();
  }

  public isEsignCompleted?: boolean;
  public firstName: string;
  public lastName: string;
  public email: string;
  public cellPhone?: string;
  public isCellPhoneUser?: boolean;
  public mfaVerifyMethod?: 'Email_Code' | 'Phone';
  public loanID: string;
  public loanNumber: string;
  public token: string;
  public consumer_id: string;
  public expires_in?: number;
  public refresh_token?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public token_time?: any;
  public userID: number;
  public userName: string;
  public borrowerId: string;
  public dataSourceId: string;
  public qFileId: string;
  public lenderCode: string;
  public dateOfBirth: string;
  public settings: UserSettings;
  public firstTimeLogin: boolean;
  public isHeavyRegistration?: boolean;
  public confetti: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public loans?: any;
  public loginType?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public consumerIdentity?: any;
  public registeredWithSSO?: boolean;
  public isAdminPortalLogin: boolean;
  /** Provides access to pre-accepted consents */
  public consentAcceptences?: { acknowledgeId: string; versionStamp: number }[];
}

export class UserSignup {
  public firstName: string;
  public lastName: string;
  public dob: Date;
  public email: string;
  public ssn: string;
  public passwordCreate: string;
  public passwordConfirm: string;
}
export class SignupInfo {
  public qFileId: string;
  public borrowerId: string;
  public dataSourceId: string;
}

export class UserSettings {
  public primaryPhoneNumber: string;
  public alternatePhoneNumber: string;
  public contactMethod: string;
}

export class Registration {
  public AccessToken: string;
  public lenderCode: string;
  public consumerId: string;
  public email: string;
  public createdTime: string;
  public lastModified: string;
  public redirectUri: string;
}
